// extracted by mini-css-extract-plugin
export default {"your-recent-searches":"WidgetYourRecentSearches_your-recent-searches__EjfwP"};